/*
Render purchase order form
*/

import _ from 'lodash';
import moment from 'moment-timezone';

import './style.styl';

angular
  .module(__filename, [])

  .directive(
    'purchaseOrderSummary',
    ngInject(() => ({
      restrict: 'E',
      scope: {
        purchaseOrder: '=',
        lineItems: '=',
        foodhub: '=',
      },
      template: require('./template'),
      controllerAs: 'ctrl',
      bindToController: true,
      controller: ngInject(function($scope) {
        const formatDateTime = (date) =>
          moment.tz(date, this.foodhub.tzid).format('MM/DD/YYYY hh:mma');

        const calculatePurchaseOrderStatusHistory = () =>
          (this.purchaseOrderStatusHistory = (() => {
            const historyItems = [];
            if (this.purchaseOrder.submittedAt != null) {
              historyItems.push({
                id: 'submitted-at',
                label: 'Submitted to vendor',
                value: formatDateTime(this.purchaseOrder.submittedAt),
              });
            }

            if (this.purchaseOrder.confirmedAt != null) {
              historyItems.push({
                id: 'confirmed-at',
                label: `Confirmed by ${
                  this.purchaseOrder.confirmedByVendor ? 'vendor' : 'Good Eggs'
                }`,
                value: formatDateTime(this.purchaseOrder.confirmedAt),
              });
            } else {
              historyItems.push({
                id: 'confirm-by',
                label: 'Confirm-by',
                value: formatDateTime(this.purchaseOrder.confirmBy),
              });
            }

            if (this.purchaseOrder.vendorArrivedAt != null) {
              historyItems.push({
                id: 'vendor-arrived-at',
                label: 'Vendor arrived',
                value: formatDateTime(this.purchaseOrder.vendorArrivedAt),
              });
            }

            if (this.purchaseOrder.receivedAt != null) {
              const receivedBy = (() => {
                const receivers = _(this.lineItems)
                  .map((lineItem) => lineItem.receivedBy)
                  .uniq()
                  .compact()
                  .value();
                if (receivers.length) {
                  return receivers.join(', ');
                }
                return 'unknown';
              })();
              historyItems.push({
                id: 'received-at',
                label: `Received at Good Eggs by ${receivedBy}`,
                value: formatDateTime(this.purchaseOrder.receivedAt),
              });
            }

            return historyItems;
          })());

        $scope.$watch(
          () => this.purchaseOrder.vendorArrivedAt,
          function(newValue, oldValue) {
            if (newValue === oldValue) {
              return;
            }
            return calculatePurchaseOrderStatusHistory();
          },
        );

        $scope.$watch(
          () => this.purchaseOrder != null && this.lineItems != null && this.foodhub != null,
          (isAllDataDefined) => {
            if (!isAllDataDefined) {
              return;
            }
            return calculatePurchaseOrderStatusHistory();
          },
        );

        this.formatDay = (day) =>
          moment.tz(day, 'YYYY-MM-DD', this.foodhub.tzid).format('MM/DD/YYYY');

        return this;
      }),
    })),
  );

export default __filename;
